"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _reactAddonsShallowCompare = _interopRequireDefault(require("react-addons-shallow-compare"));

var _reactPullToRefresh = _interopRequireDefault(require("react-pull-to-refresh"));

var _Tabs = require("react-mdl/lib/Tabs");

var _List = require("react-mdl/lib/List");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _APIService = _interopRequireDefault(require("./services/APIService"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _DataObjectService = _interopRequireDefault(require("./services/DataObjectService"));

var _index = _interopRequireDefault(require("../Button/index"));

var _RunningGames = _interopRequireDefault(require("./RunningGames"));

var _QuizOpponents = _interopRequireDefault(require("./QuizOpponents"));

var _QuizHighScores = _interopRequireDefault(require("./QuizHighScores"));

var _QuizLeagueHighScores = _interopRequireDefault(require("./QuizLeagueHighScores"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _Quiz = _interopRequireDefault(require("./Quiz.scss"));

var _QuizHome = _interopRequireDefault(require("./QuizHome.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _QuizStrings = require("./QuizStrings");

var _UserProfile = _interopRequireDefault(require("./UserProfile"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _QuizHomeStyle = require("./styles/QuizHomeStyle");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _ExternalWebsite = _interopRequireDefault(require("../ExternalWebsite/ExternalWebsite"));

var _Constants = require("../../constants/Constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PUSH_DELAY = 2000;
var TEXTFIELD_PUSH_MESSAGE_ID = 'textfield_push_message'; // eslint-disable-next-line no-template-curly-in-string

var LEARNING_PROGRESS_URL = 'https://equeoqd-stats.equeo.de?inApp=1&deviceuuid=${deviceuuid}&app_username=${app_username}&app_password=${app_password}&requestCode=${request_code(equeoqd)}&username=${userid(equeoqd)}&theme=${current_theme}&lang=${lang}&app_host=${app_host}';

var QuizHome = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizHome, _DataStoreComponent);

  var _super = _createSuper(QuizHome);

  function QuizHome(props, context) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizHome);
    _this = _super.call(this, props, context);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLastLocation", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var location;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _NavigationManager["default"].getLastLocation();

            case 2:
              location = _context.sent;
              console.log('LOCATION', location);

              if (location === 'running_games') {
                _this.setState({
                  activeTab: _this.getTabIndexes().MY_GAMES
                });
              } else if (location === 'quiz_opponents') {
                _this.setState({
                  activeTab: _this.getTabIndexes().ALL_PLAYERS
                });
              } else if (location === 'quiz_highscores') {
                _this.setState({
                  activeTab: _this.getTabIndexes().HIGHSCORES
                });
              } else if (location === 'quiz_league') {
                _this.setState({
                  activeTab: _this.getTabIndexes().LEAGUE
                });
              } else if (location === 'quiz_progression') {
                _this.setState({
                  activeTab: _this.getTabIndexes().PROGRESSION
                });
              } else {
                _this.setState({
                  activeTab: _this.getTabIndexes().MY_GAMES
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function () {
      if (_DeviceInfoHelper["default"].isAndroid()) {
        var alertHelperInput = document.querySelector('.equizzer-modal div div:nth-child(2)');

        _this.setState({
          modalTop: alertHelperInput.style.top
        });

        console.log('on focus', _this.state.modalTop);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      if (_DeviceInfoHelper["default"].isAndroid()) {
        console.log('on blur', _this.state.modalTop);
        var alertHelperInput = document.querySelector('.equizzer-modal div div:nth-child(2)');
        alertHelperInput.style.top = _this.state.modalTop;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showResults", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(game, opponent) {
        var _UserService$getPlaye, userData, selectedOpponentData, data;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (game) {
                  _context2.next = 3;
                  break;
                }

                _this.props.onStartRound(null, opponent);

                return _context2.abrupt("return");

              case 3:
                // get the player state (challenger or opponent)
                _UserService$getPlaye = _UserService["default"].getPlayerState(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], opponent, game), userData = _UserService$getPlaye.userData, selectedOpponentData = _UserService$getPlaye.selectedOpponentData;
                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_GAME] = game;
                data[_DataStore.DATA_STORE_PATHS.QD_USER] = userData;
                data[_DataStore.DATA_STORE_PATHS.QD_USER_POINTS] = userData.points;
                data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT] = selectedOpponentData;
                _context2.next = 11;
                return _DataStore["default"].setData(data, false);

              case 11:
                // redirect to game overview screen
                _this.props.onFinishedGame(game, true);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendMessageToOpponent", function (opponent) {
      if (_this.sendPushAllowed === true) {
        _this.sendPushAllowed = false;
        _this.pushMessage = '';
        var textBoxes = [{
          label: (0, _QuizStrings.getString)('ENTER_MESSAGE'),
          id: TEXTFIELD_PUSH_MESSAGE_ID,
          value: _this.pushMessage,
          onChange: _this.setPushMessage,
          onFocus: _this.onFocus,
          onBlur: _this.onBlur,
          ref: function ref(_ref3) {
            _this.textfield = _ref3;
          },
          maxLength: 50
        }];
        (0, _AlertHelper.showWideAlertHtmlWithTextfields)((0, _QuizStrings.getString)('PUSH_REMINDER_EXPLANATION', [opponent.nickname]), (0, _QuizStrings.getString)('PUSH_REMINDER'), null, textBoxes, true, null, [{
          label: (0, _QuizStrings.getString)('SEND_PUSH'),
          callback: function callback() {
            _this.sendPush(opponent, _this.pushMessage);
          }
        }, {
          label: (0, _QuizStrings.getString)('PUSH_RANDOM'),
          callback: function callback() {
            _this.getRandomPushMessage();
          },
          remove: false
        }]);
        setTimeout(function () {
          _this.sendPushAllowed = true;
        }, PUSH_DELAY);
      } else {
        console.log('sending push not allowed');
        setTimeout(function () {
          (0, _AlertHelper.showAlertWithOptions)({
            html: (0, _QuizStrings.getString)('PUSH_TOO_OFTEN'),
            title: (0, _QuizStrings.getString)('PUSH_TOO_OFTEN_TITLE'),
            centeredContent: true
          }); // showWideAlertHtml(getString('PUSH_TOO_OFTEN'), getString('PUSH_TOO_OFTEN_TITLE'))
        }, 0);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPushMessage", function (event) {
      var pushMessage = event.target.value;
      console.log(pushMessage); // this.setState({pushMessage: pushMessage});

      _this.pushMessage = pushMessage;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRandomPushMessage", function () {
      var user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
      var messages = [(0, _QuizStrings.getString)('RANDOM_PUSH_1', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_2', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_3', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_4', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_5', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_6', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_7', [user.nickname]), (0, _QuizStrings.getString)('RANDOM_PUSH_8', [user.nickname])];
      var randomNumber = Math.floor(Math.random() * messages.length);
      document.getElementById(TEXTFIELD_PUSH_MESSAGE_ID).focus();
      document.getElementById(TEXTFIELD_PUSH_MESSAGE_ID).value = messages[randomNumber]; // this.setState({pushMessage: messages[randomNumber]});

      _this.pushMessage = messages[randomNumber];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendPush", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(receiver, message) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(message.length > 0)) {
                  _context3.next = 17;
                  break;
                }

                _context3.prev = 1;
                _context3.t0 = _APIService["default"];
                _context3.t1 = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id;
                _context3.t2 = receiver.id;
                _context3.t3 = message;
                _context3.next = 8;
                return _this.props.getAuthToken();

              case 8:
                _context3.t4 = _context3.sent;
                _context3.next = 11;
                return _context3.t0.sendPush.call(_context3.t0, _context3.t1, _context3.t2, _context3.t3, _context3.t4);

              case 11:
                // LOG: custom push event
                _UserLogsService["default"].postSendCustomPushLog(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, receiver.id);

                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t5 = _context3["catch"](1);
                console.log(_context3.t5);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 14]]);
      }));

      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setUserImage", function (img) {
      _this.setState({
        userImage: img
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pullToRefresh", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
        var tabIndexes;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this.state.currentlyUpdating === true)) {
                  _context4.next = 3;
                  break;
                }

                reject();
                return _context4.abrupt("return");

              case 3:
                _this.setState({
                  currentlyUpdating: true
                });

                tabIndexes = _this.getTabIndexes();

                if (!(_this.state.activeTab === tabIndexes.MY_GAMES)) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 8;
                return _this.runningGames.updateTab();

              case 8:
                console.log('finished updating running games');

                _this.setState({
                  currentlyUpdating: false
                });

                resolve();
                _context4.next = 22;
                break;

              case 13:
                if (!(_this.state.activeTab === tabIndexes.ALL_PLAYERS)) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 16;
                return _this.quizOpponents.updateTab();

              case 16:
                console.log('finished updating quiz opponents');

                _this.setState({
                  currentlyUpdating: false
                });

                resolve();
                _context4.next = 22;
                break;

              case 21:
                if (_this.state.activeTab === tabIndexes.HIGHSCORES) {
                  // await this.quizHighScores.updateTab();
                  // console.log('finished updating quiz highscores');
                  // this.setState({currentlyUpdating: false});
                  resolve();
                } else {
                  resolve();
                }

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    _this.state = {
      pushMessage: '',
      modalTop: 0,
      activeTab: 0,
      currentlyUpdating: false
    };
    _this.pushMessage = '';
    _this.sendPushAllowed = true;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizHome.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['runningQuiz', 'currentTheme', 'quiz']
    }]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizHome.prototype)), "setDataStorePaths", _thisSuper2).call(_thisSuper2, [_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_COMPLETED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_EXPIRED_GAME_IDS, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_USER_POINTS, _DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]);
    return _this;
  }

  (0, _createClass2["default"])(QuizHome, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setTitle((0, _QuizStrings.getString)('RUNNING_GAMES'));
      console.log('quizhome did mount', this.state);

      if (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME] && (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME] || this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME].length === 0)) {
        if (!this.props.tournamentMode) {
          this.setState({
            activeTab: this.getTabIndexes().ALL_PLAYERS
          });
        }
      }

      this.getLastLocation();
    }
  }, {
    key: "getTabIndexes",
    value: function getTabIndexes() {
      var feedbackHiddenByGroup = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      if (this.props.tournamentMode) {
        return {
          MY_GAMES: 0 // TOURNAMENT_OPPONENTS: 1

        };
      }

      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]) {
        return {
          LEAGUE: 0,
          MY_GAMES: 1,
          ALL_PLAYERS: 2,
          HIGHSCORES: 3
        };
      }

      if (_config["default"].qdWithoutMenu) {
        return {
          MY_GAMES: 0,
          ALL_PLAYERS: 1,
          HIGHSCORES: 2,
          PROGRESSION: 3
        };
      }

      if (feedbackHiddenByGroup) {
        return {
          MY_GAMES: 0,
          ALL_PLAYERS: 1
        };
      }

      return {
        MY_GAMES: 0,
        ALL_PLAYERS: 1,
        HIGHSCORES: 2
      };
    }
  }, {
    key: "renderList",
    value: function renderList(dynamicStyles, opponentDetails) {
      var _this2 = this;

      var tabIndexes = this.getTabIndexes();

      if (this.props.tournamentMode) {
        return /*#__PURE__*/_react["default"].createElement(_List.List, {
          className: window.innerHeight > _Constants.MIN_TABLET_LENGTH ? _QuizHome["default"].listTournamentTablet : _QuizHome["default"].listTournament,
          style: dynamicStyles.listStyle
        }, /*#__PURE__*/_react["default"].createElement(_RunningGames["default"], {
          hidden: this.state.activeTab !== tabIndexes.MY_GAMES,
          ref: function ref(el) {
            return _this2.runningGames = el;
          },
          opponents: opponentDetails,
          user: this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER],
          onShowResults: this.showResults,
          onSentPushToOpponent: this.sendMessageToOpponent,
          showSpinner: this.props.showSpinner,
          setTitle: this.props.setTitle,
          isTournament: this.props.tournamentMode,
          onSetOpponent: this.props.onSetOpponent,
          onNextRound: this.props.onNextRound,
          onStartRound: this.props.onStartRound,
          onChooseCategory: this.props.onChooseCategory,
          getAuthToken: this.props.getAuthToken
        }));
      }

      return /*#__PURE__*/_react["default"].createElement(_List.List, {
        className: _QuizHome["default"].list,
        style: dynamicStyles.listStyle
      }, /*#__PURE__*/_react["default"].createElement(_RunningGames["default"], {
        hidden: this.state.activeTab !== tabIndexes.MY_GAMES,
        ref: function ref(el) {
          return _this2.runningGames = el;
        },
        opponents: opponentDetails,
        user: this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER],
        onShowResults: this.showResults,
        onSentPushToOpponent: this.sendMessageToOpponent,
        showSpinner: this.props.showSpinner,
        setTitle: this.props.setTitle,
        onSetOpponent: this.props.onSetOpponent,
        onNextRound: this.props.onNextRound,
        onStartRound: this.props.onStartRound,
        onChooseCategory: this.props.onChooseCategory,
        getAuthToken: this.props.getAuthToken
      }), /*#__PURE__*/_react["default"].createElement(_QuizOpponents["default"], {
        hidden: this.state.activeTab !== tabIndexes.ALL_PLAYERS,
        ref: function ref(el) {
          return _this2.quizOpponents = el;
        },
        onBack: this.props.onBack,
        showSpinner: this.props.showSpinner,
        setTitle: this.props.setTitle,
        onShowResults: this.showResults,
        onSetOpponent: this.props.onSetOpponent,
        getAuthToken: this.props.getAuthToken
      }), /*#__PURE__*/_react["default"].createElement(_QuizHighScores["default"], {
        hidden: this.state.activeTab !== tabIndexes.HIGHSCORES,
        ref: function ref(el) {
          return _this2.quizHighScores = el;
        },
        userImage: this.state.userImage,
        showSpinner: this.props.showSpinner,
        setTitle: this.props.setTitle,
        onShowResults: this.showResults,
        onSetOpponent: this.props.onSetOpponent,
        getAuthToken: this.props.getAuthToken
      }), _config["default"].qdWithoutMenu && /*#__PURE__*/_react["default"].createElement(_ExternalWebsite["default"], {
        externalWebsiteSendsMessages: true,
        url: LEARNING_PROGRESS_URL,
        hidden: this.state.activeTab !== tabIndexes.PROGRESSION
      }));
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      var _this3 = this;

      var dynamicStyles = (0, _QuizHomeStyle.getStyles)(this.state);
      var hasLeague = Boolean(this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]);
      var tabIndexes = this.getTabIndexes();

      var feedbackHiddenByGroup = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      var tabs = [];

      if (this.props.tournamentMode) {
        dynamicStyles.tabStyle.backgroundColor = '#0F3764';
        tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
          key: "tab_".concat(tabs.length),
          className: _QuizHome["default"].tabNoCaps,
          style: this.state.activeTab === tabIndexes.MY_GAMES ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
        }, (0, _QuizStrings.getString)('MY_GAMES')));
      } else {
        if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME]) {
          tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
            key: "tab_".concat(tabs.length),
            className: _QuizHome["default"].tab,
            style: this.state.activeTab === tabIndexes.LEAGUE ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
          }, (0, _QuizStrings.getString)('LEAGUE')));
        }

        tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
          key: "tab_".concat(tabs.length),
          className: _QuizHome["default"].tab,
          style: this.state.activeTab === tabIndexes.MY_GAMES ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
        }, (0, _QuizStrings.getString)("MY_GAMES".concat(hasLeague ? '_LEAGUE' : ''))));
        tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
          key: "tab_".concat(tabs.length),
          className: _QuizHome["default"].tab,
          style: this.state.activeTab === tabIndexes.ALL_PLAYERS ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
        }, (0, _QuizStrings.getString)("ALL_PLAYERS".concat(hasLeague ? '_LEAGUE' : ''))));

        if (!feedbackHiddenByGroup) {
          tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
            key: "tab_".concat(tabs.length),
            className: _QuizHome["default"].tab,
            style: this.state.activeTab === tabIndexes.HIGHSCORES ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
          }, (0, _QuizStrings.getString)("HIGHSCORES".concat(hasLeague ? '_LEAGUE' : ''))));
        }

        if (_config["default"].qdWithoutMenu) {
          tabs.push( /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
            key: "tab_".concat(tabs.length),
            className: _QuizHome["default"].tab,
            style: this.state.activeTab === tabIndexes.PROGRESSION ? dynamicStyles.tabStyleActive : dynamicStyles.tabStyle
          }, (0, _QuizStrings.getString)('QUIZ_PROGRESSION')));
        }
      } //    console.log('active tab', this.state.activeTab)


      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.tournamentMode ? _QuizHome["default"].tabsContainerTournament : _QuizHome["default"].tabsContainer
      }, /*#__PURE__*/_react["default"].createElement(_Tabs.Tabs, {
        activeTab: this.state.activeTab,
        ripple: true,
        onChange: function onChange(tabId) {
          return setTimeout(function () {
            console.log('setting active tab to', tabId);

            _this3.setState({
              activeTab: tabId
            });
          }, 0);
        }
      }, tabs));
    }
  }, {
    key: "render",
    value: function render() {
      // get all opponent details mapped to ID
      var opponentDetails = _UserService["default"].mapOpponentsInfoToId(this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS]); // get single latestGame with each opponent
      // let latestGames = GameService.getFilteredGames(this.state.allGame, this.state.user);


      var dynamicStyles = (0, _QuizHomeStyle.getStyles)(this.state);
      var className;

      if (this.props.tournamentMode) {
        if (this.props.sidebarDocked) {
          className = _QuizHome["default"].homeHeaderTournamentWidescreen;
        } else {
          if (window.innerHeight > _Constants.MIN_TABLET_LENGTH) {
            className = _QuizHome["default"].homeHeaderTournamentTablet;
          } else {
            className = _QuizHome["default"].homeHeaderTournament;
          }
        }
      } else {
        if (!_config["default"].qdWithoutMenu && this.props.sidebarDocked) {
          className = _QuizHome["default"].homeHeaderWidescreen;
        } else {
          className = _QuizHome["default"].homeHeader;
        }
      }

      if (this.props.isInKesi) {
        className += " ".concat(_QuizHome["default"].homeHeaderKesi);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].contentHome
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        style: dynamicStyles.homeStyle
      }, /*#__PURE__*/_react["default"].createElement(_reactPullToRefresh["default"], {
        onRefresh: this.pullToRefresh,
        distanceToRefresh: 50,
        style: {
          textAlign: 'center',
          height: '200%',
          overflowY: 'hidden',
          paddingBottom: 0,
          resistence: 10,
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_UserProfile["default"], {
        userInfo: this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER],
        onSetUserImage: this.setUserImage,
        tournamentMode: this.props.tournamentMode,
        getAuthToken: this.props.getAuthToken
      }), this.renderTabs())), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizHome["default"].listContainer,
        style: dynamicStyles.homeStyle
      }, this.renderList(dynamicStyles, opponentDetails)));
    }
  }]);
  return QuizHome;
}(_DataStoreComponent2["default"]);

QuizHome.propTypes = {
  onStartRound: _propTypes["default"].func.isRequired,
  onChooseCategory: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  onBack: _propTypes["default"].func.isRequired,
  onOpenHome: _propTypes["default"].func.isRequired,
  onSetOpponent: _propTypes["default"].func.isRequired,
  sidebarDocked: _propTypes["default"].bool,
  tournamentMode: _propTypes["default"].bool,
  onNextRound: _propTypes["default"].func.isRequired,
  setTitle: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  isInKesi: _propTypes["default"].bool,
  changePage: _propTypes["default"].func
};
QuizHome.defaultProps = {
  isInKesi: false
};
var _default = QuizHome;
exports["default"] = _default;